import { CandyMachine, CollectionPDA } from '@metaplex-foundation/mpl-candy-machine';
import { getAccountParsingFunction, getAccountParsingAndAssertingFunction } from '../../types/Account.mjs';

/** @group Accounts */

/** @group Account Helpers */
const parseCandyMachineV2Account = getAccountParsingFunction(CandyMachine);

/** @group Account Helpers */
const toCandyMachineV2Account = getAccountParsingAndAssertingFunction(CandyMachine);

/** @group Accounts */

/** @group Account Helpers */
const parseCandyMachineV2CollectionAccount = getAccountParsingFunction(CollectionPDA);

/** @group Account Helpers */
const toCandyMachineV2CollectionAccount = getAccountParsingAndAssertingFunction(CollectionPDA);

export { parseCandyMachineV2Account, parseCandyMachineV2CollectionAccount, toCandyMachineV2Account, toCandyMachineV2CollectionAccount };
//# sourceMappingURL=accounts.mjs.map
